import { Component, OnInit } from '@angular/core';
import {PaymentService} from '../../services/payment.service';
import { MdDialog, MdDialogRef } from '@angular/material';
import { PaymentDialogComponent } from '../payment-dialog/payment-dialog.component';
import { TransactionDetailDialogComponent } from "../transaction-detail-dialog/transaction-detail-dialog.component";

@Component({
  selector: 'app-view-transaction',
  templateUrl: './view-transaction.component.html',
  styleUrls: ['./view-transaction.component.css']
})
export class ViewTransactionComponent implements OnInit {

  public transactions: any;
  page: number;
  total: number;
  max: number;
  loading: boolean;

  public orders: any;
  loadingOrders: boolean;
  pageOrders: number;
  totalOrders: number;
  maxOrders: number;

  constructor(
    public paymentService: PaymentService,
    public dialog: MdDialog,
  ) {
    this.loading = true;
    this.page = 1;
    this.total = 0;
    this.max = 5;

    this.pageOrders = 1;
    this.totalOrders = 0;
    this.maxOrders = 5;
  }

  ngOnInit() {
    this.searchOrders();
    this.searchTransactions();
  }

  searchTransactions (page?: number, query?: string, active?: boolean, deleted?: boolean) {
    this.loading = true;

    if (page == null) {
      page = 1;
      this.page = page;
    }
    this.page = page;

    this.paymentService.getTransaction(this.page, this.max)
    .subscribe(
    data => {
      this.transactions = data.transaction;
      this.total = data.pagination.total;
      this.loading = false;
    },
    error => {
      if (error.status == 404) {
        this.transactions = undefined;
        this.loading = false;
      } else {
        console.log(error);
        this.transactions = undefined;
        this.loading = false;
      }
    });
  }

  searchOrders (page?: number, query?: string, active?: boolean, deleted?: boolean) {
    this.loadingOrders = true;

    if (page == null) {
      page = 1;
    }
    this.pageOrders = page;

    this.paymentService.getOrders(this.pageOrders, this.maxOrders)
    .subscribe(
    data => {
      this.orders = data.order;
      this.totalOrders = data.pagination.total;
      this.loadingOrders = false;
    },
    error => {
      if (error.status == 404) {
        this.orders = undefined;
        this.loadingOrders = false;
      } else {
        console.log(error);
        this.orders = undefined;
        this.loadingOrders = false;
      }
    });
  }

  onPageChange(page) {
    this.searchTransactions (page);
  }

  onPageChangeOrders(page) {
    this.searchOrders (page);
  }

  openDialogPaymentCredits() {
    let dialogRef = this.dialog.open(PaymentDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      this.searchOrders();
      this.searchTransactions();
    });
  }

  openDialogDetailTransaction(transaction) {
    let dialogRef = this.dialog.open(TransactionDetailDialogComponent, {
      data: {transaction: transaction}
    });
  }

  getTotal(order) {
    return Number(order.amount) - Number(order.discount);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-transaction/view-transaction.component.ts